import { render, staticRenderFns } from "./PaginationCom.vue?vue&type=template&id=2a329552&scoped=true"
import script from "./PaginationCom.vue?vue&type=script&lang=js"
export * from "./PaginationCom.vue?vue&type=script&lang=js"
import style0 from "./PaginationCom.vue?vue&type=style&index=0&id=2a329552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c221fa3cdd5e19547e7a9f9e993c3df2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a329552",
  null
  
)

export default component.exports